import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default function ApprovedInstallers() {
  const [installers, setInstallers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchApprovedInstallers();
  }, []);

  const fetchApprovedInstallers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/services?status=approved&type=installer");
      setInstallers(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch approved installers.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "50px auto", padding: "20px" }}>
      <h2>Approved Installers</h2>

      {loading ? (
        <p>Loading approved installers...</p>
      ) : installers.length === 0 ? (
        <p>No approved installers available at the moment.</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
          {installers.map((installer) => (
            <div key={installer._id} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "15px", backgroundColor: "#f9f9f9" }}>
              {installer.images && installer.images.length > 0 && (
                <img src={installer.images[0]} alt={installer.name} style={{ width: "100%", borderRadius: "5px", marginBottom: "10px" }} />
              )}
              <h3>{installer.name}</h3>
              <p><strong>Location:</strong> {installer.location}</p>
              <p><strong>Address:</strong> {installer.address}</p>
              <p><strong>Description:</strong> {installer.description}</p>
              <p><strong>Phone:</strong> {installer.phone}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
